import Helpers from "../helpers/shared.helper";
import HTTP from "./http.service";
import Translation from "./translation.service";

var OTPService = {};

OTPService.requestOTP = (data, flowType) => {
    let flow_types = Helpers.getPOValue("otp_flow_type", "");
    let apiData = data;
    if(flow_types) {
        apiData["flow_type"] = flow_types[flowType]
    }
    let config = {
        method: "post",
        url: "/otp/request_otp",
        data: apiData,
        headers: {
          "Virgin-Lang": Translation.getCurrentLanguage(),
        }
    };
    return HTTP(config);
};

OTPService.validateOTP = data => {
    let config = {
      method: "post",
      url: "/otp/validate_otp",
      data: data,
      headers: {
        "Virgin-Lang": Translation.getCurrentLanguage(),
      }
    };
    return HTTP(config);
  };
  
export default OTPService;
